export default "__VITE_ASSET___emzIqYs__"